<template>
  <drag-modal :visible="visible" @cancel="close" title='修改密码' width='540px'>
    <div class="repass">
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{span: 6}" :wrapper-col="{span: 14}">
        <a-form-model-item label="原密码" :rules="{ required: true, message: '请输入原密码',trigger: 'change'}">
          <a-input v-model="form.password" placeholder='请输入原密码' />
        </a-form-model-item>
        <a-form-model-item label="新密码" :rules="{ required: true, message: '请输入新密码',trigger: 'change'}">
          <a-input v-model="form.new_password" placeholder='请输入新密码' />
        </a-form-model-item>
        <a-form-model-item label="确认新密码" :rules="{ required: true, message: '请确认新密码',trigger: 'change'}">
          <a-input v-model="form.aggin_password" placeholder='确认新密码' />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click='sub'>
            提交
          </a-button>
          <a-button style="margin-left: 10px;" @click='close'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>

</template>
<script>
import { repass } from "@/server/api"
export default {
  props: {
    visible: false
  },
  data() {
    return {
      form: {
        password: null,
        new_password: null,
        aggin_password: null
      },
      rules: {},
    }
  },
  methods: {
    sub() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          if (form.new_password != form.aggin_password) {
            this.$message.success("确认密码不相同")
            return false;
          }
          delete form.aggin_password
          repass(form).then(e => {
            this.$message.success({ content: '修改密码成功', key: 'updatable' });
            localStorage.clear();
            this.$router.replace({ name: 'login' })
          })
        } else {

        }
      })
    },
    close() {
      this.$emit("close")
    }
  }
}
</script>